import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconSettings: TIconComponent = props => (
    <Icon viewBox="0 0 16 16" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 14C0.447715 14 0 14.4477 0 15C0 15.5523 0.447715 16 1 16H5H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H5H1ZM5 14C5.55228 14 6 14.4477 6 15C6 15.5523 5.55228 16 5 16C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14Z"
                fill="#333333"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 18C6.65685 18 8 16.6569 8 15C8 13.3431 6.65685 12 5 12C3.34315 12 2 13.3431 2 15C2 16.6569 3.34315 18 5 18ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14C4.44771 14 4 14.4477 4 15C4 15.5523 4.44771 16 5 16Z"
                fill="#333333"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 10C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8L15 8L1 8C0.447716 8 1.35705e-07 8.44771 8.74228e-08 9C3.91405e-08 9.55228 0.447716 10 1 10L15 10L19 10ZM15 10C14.4477 10 14 9.55228 14 9C14 8.44771 14.4477 8 15 8C15.5523 8 16 8.44771 16 9C16 9.5523 15.5523 10 15 10Z"
                fill="#333333"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 6C13.3431 6 12 7.34315 12 9C12 10.6569 13.3431 12 15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6ZM15 8C14.4477 8 14 8.44771 14 9C14 9.55228 14.4477 10 15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8Z"
                fill="#333333"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 2C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4H9H19C19.5523 4 20 3.55228 20 3C20 2.44772 19.5523 2 19 2H9H1ZM9 2C9.55229 2 10 2.44772 10 3C10 3.55228 9.55229 4 9 4C8.44771 4 8 3.55228 8 3C8 2.44772 8.44771 2 9 2Z"
                fill="#333333"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 6C10.6569 6 12 4.65685 12 3C12 1.34315 10.6569 0 9 0C7.34315 0 6 1.34315 6 3C6 4.65685 7.34315 6 9 6ZM9 4C9.55228 4 10 3.55228 10 3C10 2.44772 9.55228 2 9 2C8.44771 2 8 2.44772 8 3C8 3.55228 8.44771 4 9 4Z"
                fill="#333333"
            />
        </svg>
    </Icon>
);
